// React
import React from 'react';
import { Controller } from 'react-hook-form';
// material-ui components
import Divider from '@mui/material/Divider';
import Select from '@mui/material/Select';
import MenuItem from '@mui/material/MenuItem';
import FormHelperText from '@mui/material/FormHelperText';
import FormControl from '@mui/material/FormControl';

import TextField from '@mui/material/TextField';
import FormControlLabel from '@mui/material/FormControlLabel';
import Checkbox from '@mui/material/Checkbox';
// custom components
import NumberedHeading from "../../../../../shared-components/forms/NumberedHeading";
import WYSIWYGEditor from "../../../../../shared-components/WYSIWYGEditor";
import EmentorArray from '../shared/EmentorArray';

const PECompletionEvent = (props) => {

  const { control, formState } = props.methods;
  const { errors } = formState;

  const { inputDir } = props;

  return (
    <div>
      <NumberedHeading number="1" title="Summary Statement (TL)" instructions="Enter the custom Target Lnaguage feedback for the previous event." />
      <Controller
        control={control}
        name="content.core.text_tl"
        render={({ field }) => <WYSIWYGEditor {...field} error={errors.content?.core?.text_tl} />}
      />

      <Divider className="my-16" />

      <NumberedHeading number="2" title="Summary Statement (EN)" instructions="Enter the custom English feedback for the previous event." />
      <Controller
        control={control}
        name="content.core.text_en"
        render={({ field }) => <WYSIWYGEditor {...field} error={errors.content?.core?.text_en} />}
      />

      <Divider className="my-16" />

      <NumberedHeading number="3" title="Unlocked Item" instructions="Select the type of item that was unlocked during this PE thread." />
      <Controller
        control={control}
        name="content.core.unlock_id"
        render={({ field }) => (
          <Controller
            control={control}
            name="content.core.unlock_id"
            render={({ field }) => (
              <FormControl fullWidth className="mt-16" error={!!errors.content?.core?.unlock_id}>
                <Select
                  {...field}
                  id="unlock_id"
                  classes={{ select: "flex items-center space-x-12" }}
                  inputProps={{ "aria-label": "Unlocked Item" }}
                  required
                >
                  <MenuItem value={0} className="space-x-12">
                    None
                  </MenuItem>
                  <MenuItem value={1} className="space-x-12">
                    Reading
                  </MenuItem>
                  <MenuItem value={2} className="space-x-12">
                    Video
                  </MenuItem>
                  <MenuItem value={3} className="space-x-12">
                    Audio
                  </MenuItem>
                  <MenuItem value={4} className="space-x-12">
                    Note
                  </MenuItem>
                </Select>
                {!!errors.content?.core?.unlock_id && (
                  <FormHelperText>{errors.content?.core?.unlock_id?.message}</FormHelperText>
                )}
              </FormControl>
            )}
          />
        )}
      />
    </div>
  );
};

export default PECompletionEvent;